import { Navigate, Route, Routes } from 'react-router-dom';
import Dashboard from './views/Dashboard/Dashboard';
import Reviews from './views/Monitoring/Reviews/Reviews';
import Keywords from './views/Monitoring/Keywords/Keywords';
import Benchmarking from './views/Research/Benchmarking/Benchmarking';
import Locations from './views/GoogleMyBusiness/Locations/Locations';
import { default as GoogleMyBusinessReviews } from './views/GoogleMyBusiness/Reviews/Reviews';
import Evaluation from './views/GoogleMyBusiness/Evaluation/Evaluation';
import Commentings from './views/CommunityManagement/Commentings/Commentings';
import Administration from './views/Administration/Administration';
import Platforms from './views/Monitoring/Platforms/Platforms';
import Login from './views/Login/Login';
import ReviewMonitoringGuide from './views/Monitoring/Reviews/ReviewMonitoringGuide/ReviewMonitoringGuide';
import KeywordMonitoringGuide from './views/Monitoring/Keywords/KeywordMonitoringGuide/KeywordMonitoringGuide';
import AiSearches from './views/Monitoring/AiSearch/AiSearch';
import AiSearchGuide from './views/Monitoring/AiSearch/AiSearchGuide/AiSearchGuide';
import EditMonitoring from './views/Monitoring/Reviews/EditMonitoring/EditMonitoring';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import AICommentGenerator from './views/CommunityManagement/AICommentGenerator/AICommentGenerator';
import Trustpages from './views/Visibility/Trustpages/Trustpages';
import Trustpage from './views/Trustpage/Trustpage';
import NetPromoterScorePage from './views/NetPromoterScore/NetPromoterScorePage';
import ForgotPassword from './views/Login/ForgotPassword';
import ResetPassword from './views/Login/ResetPassword';
import SuccessPage from './views/Login/SuccessPage';
import LocationHistory from './views/GoogleMyBusiness/LocationHistory/LocationHistory';
import Surveys from './views/Research/SurveyTool/Surveys';
import TrustpageGuide from './views/Visibility/Trustpages/TrustpageGuide/TrustpageGuide';
import GMBAuthProvider from './providers/GMBAuthProvider';
import MoodBarometerPage from './views/MoodBarometer/MoodBarometerPage';
import StandardSurveyPage from './views/StandardSurvey/StandardSurveyPage';
import SurveyQuestions from './views/Research/SurveyTool/SurveyQuestions';
import CustomSurveyPage from './views/CustomSurvey/CustomSurveyPage';
import Analysis from './views/Monitoring/Analysis/Analysis';
import AnalysisCreate from './components/Analysis/AnalysisCreate';
import SurveyLocalization from './views/Research/SurveyTool/SurveyLocalization/SurveyLocalization';
import Groups from './views/Monitoring/Groups/Groups';
import GroupsGuide from './views/Monitoring/Groups/GroupsGuide/GroupsGuide';
import IndexRedirect from './components/IndexRedirect/IndexRedirect';
import SurveyPreviewPage from './views/SurveyPreview/SurveyPreviewPage';

const App = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute>
            <IndexRedirect />
          </ProtectedRoute>
        }
      />
      <Route
        path="/login"
        element={<Login />}
      />
      <Route
        path="/login/forgot-password"
        element={<ForgotPassword />}
      />
      <Route
        path="/login/reset-password"
        element={<ResetPassword />}
      />
      <Route
        path="/login/forgot-password/success"
        element={<SuccessPage />}
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute role="can-use-dashboard">
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/platforms"
        element={
          <ProtectedRoute>
            <Platforms />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/reviews"
        element={
          <ProtectedRoute>
            <Reviews />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/keywords"
        element={
          <ProtectedRoute>
            <Keywords />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/ai-search"
        element={
          <ProtectedRoute role="can-use-ai-search">
            <AiSearches />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/analysis/create"
        element={
          <ProtectedRoute>
            <AnalysisCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/analysis"
        element={
          <ProtectedRoute role="can-use-aireviews">
            <Analysis />
          </ProtectedRoute>
        }
      />
      <Route
        path="/googlemybusiness/locations"
        element={
          <ProtectedRoute>
            <GMBAuthProvider>
              <Locations />
            </GMBAuthProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="/googlemybusiness/reviews"
        element={
          <ProtectedRoute>
            <GMBAuthProvider>
              <GoogleMyBusinessReviews />
            </GMBAuthProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="/googlemybusiness/location-history"
        element={
          <ProtectedRoute role="can-use-history">
            <GMBAuthProvider>
              <LocationHistory />
            </GMBAuthProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="/googlemybusiness/evaluation"
        element={
          <ProtectedRoute>
            <Evaluation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/research/benchmarking"
        element={
          <ProtectedRoute>
            <Benchmarking />
          </ProtectedRoute>
        }
      />
      <Route
        path="/communitymanagement/commentings"
        element={
          <ProtectedRoute role="can-use-ai">
            <Commentings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/communitymanagement/ai-commentgenerator"
        element={
          <ProtectedRoute role="can-use-ai">
            <AICommentGenerator />
          </ProtectedRoute>
        }
      />
      <Route
        path="/research/surveytool/guide"
        element={
          <ProtectedRoute role="can-use-survey">
            <Surveys />
          </ProtectedRoute>
        }
      />
      <Route
        path="/research/surveytool/questions/:id"
        element={
          <ProtectedRoute>
            <SurveyQuestions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/research/surveytool/localize/:id"
        element={
          <ProtectedRoute>
            <SurveyLocalization />
          </ProtectedRoute>
        }
      />
      <Route
        path="/visibility/trustpages"
        element={
          <ProtectedRoute role="can-view-trustpage">
            <Trustpages />
          </ProtectedRoute>
        }
      />
      <Route
        path="/visibility/trustpages/guide"
        element={
          <ProtectedRoute>
            <TrustpageGuide />
          </ProtectedRoute>
        }
      />
      <Route
        path="/administration"
        element={
          <ProtectedRoute>
            <GMBAuthProvider>
              <Administration />
            </GMBAuthProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/groups"
        element={
          <ProtectedRoute>
            <Groups />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/groups/guide"
        element={
          <ProtectedRoute>
            <GroupsGuide />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/reviews/guide"
        element={
          <ProtectedRoute>
            <ReviewMonitoringGuide />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/platforms/guide"
        element={
          <ProtectedRoute>
            <ReviewMonitoringGuide />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/keywords/guide"
        element={
          <ProtectedRoute>
            <KeywordMonitoringGuide />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/ai-search/guide"
        element={
          <ProtectedRoute role="can-use-ai-search">
            <AiSearchGuide />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/reviews/edit"
        element={
          <ProtectedRoute>
            <EditMonitoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/platforms/edit"
        element={
          <ProtectedRoute>
            <EditMonitoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="/trustpages/:id"
        element={<Trustpage />}
      />
      {/*Survey Tool routes start*/}
      <Route
        path="/survey-preview/:type/:draftKey"
        element={<SurveyPreviewPage />}
      />
      <Route
        path="n/:id"
        element={<NetPromoterScorePage />}
      />
      <Route
        path="b/:id"
        element={<MoodBarometerPage />}
      />
      <Route
        path="s/:id"
        element={<StandardSurveyPage />}
      />
      <Route
        path="c/:id"
        element={<CustomSurveyPage />}
      />
      <Route
        path="/research/surveytool/guide/nps/:id"
        element={<NetPromoterScorePage />}
      />
      <Route
        path="/research/surveytool/guide/barometer/:id"
        element={<MoodBarometerPage />}
      />
      <Route
        path="/research/surveytool/guide/standard/:id"
        element={<StandardSurveyPage />}
      />
      {/*Survey Tool routes end*/}
    </Routes>
  );
};

export default App;
